import { put, takeLatest, all, call } from 'redux-saga/effects';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import {
  fetchInterswitchConfigFailure,
  fetchInterswitchConfigSuccess,
  fetchNabrollConfigFailure,
  fetchNabrollConfigSuccess,
  fetchPayproKanoConfigFailure,
  fetchPayproKanoConfigSuccess,
  fetchPaystackConfigFailure,
  fetchPaystackConfigSuccess,
  fetchPayUnimaidConfigFailure,
  fetchPayUnimaidConfigSuccess,
  fetchRemitaConfigFailure,
  fetchRemitaConfigSuccess,
  fetchSokotoIrsConfigFailure,
  fetchSokotoIrsConfigSuccess,
} from '../actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

const toIdList = (payload) =>
  Array.isArray(payload) ? payload.filter(Boolean) : payload ? [payload] : [];

function* fetchPaystackConfig({ payload: paystack }) {
  const ids = toIdList(paystack);
  if (ids.length) {
    const paystackResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = paystackResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchPaystackConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchPaystackConfigFailure('No Paystack configs could be loaded.')
      );
      if (paystackResponses.statusCode === 404) {
        networkErrorHandler(
          paystackResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          paystackResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchNabrollConfig({ payload: nabroll }) {
  const ids = toIdList(nabroll);
  if (ids.length) {
    const nabrollResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = nabrollResponses
      .filter((res) => res.success)
      .map((res) => res.raw);
    if (successfulConfigs.length) {
      yield put(fetchNabrollConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchNabrollConfigFailure(
          'An error occured. Please reload the page to try again.'
        )
      );
      if (nabrollResponses.statusCode === 404) {
        networkErrorHandler(
          nabrollResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          nabrollResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchRemitaConfig({ payload: remita }) {
  const ids = toIdList(remita);
  if (ids.length) {
    const remitaResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = remitaResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchRemitaConfigSuccess(successfulConfigs));
    } else {
      yield put(fetchRemitaConfigFailure('No Remita configs could be loaded.'));
      if (remitaResponses.statusCode === 404) {
        networkErrorHandler(
          remitaResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          remitaResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}

function* fetchInterswitchConfig({ payload: interswitch }) {
  const ids = toIdList(interswitch);
  if (ids.length) {
    const interSwitchResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = interSwitchResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchInterswitchConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchInterswitchConfigFailure(
          'An error occured. Please reload the page to try again.'
        )
      );
      if (interSwitchResponses.statusCode === 404) {
        networkErrorHandler(
          interSwitchResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          interSwitchResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchPayproKanoConfig({ payload: payproKano }) {
  const ids = toIdList(payproKano);
  if (ids.length) {
    const payproKanoResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = payproKanoResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchPayproKanoConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchPayproKanoConfigFailure('No Paypro Kano configs could be loaded.')
      );
      if (payproKanoResponses.statusCode === 404) {
        networkErrorHandler(
          payproKanoResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          payproKanoResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}

function* fetchPayUnimaidConfig({ payload: payUnimaid }) {
  const ids = toIdList(payUnimaid);

  if (ids.length) {
    const payUnimaidResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = payUnimaidResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchPayUnimaidConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchPayUnimaidConfigFailure('No PayUnimaid configs could be loaded.')
      );
      if (payUnimaidResponses.statusCode === 404) {
        networkErrorHandler(
          payUnimaidResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          payUnimaidResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchSokotoIrsConfig({ payload: sokotoIrs }) {
  const ids = toIdList(sokotoIrs);
  if (ids.length) {
    const sokotoIrsResponses = yield all(
      ids.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = sokotoIrsResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchSokotoIrsConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchSokotoIrsConfigFailure('No Sokoto IRS configs could be loaded.')
      );
      if (sokotoIrsResponses.statusCode === 404) {
        networkErrorHandler(
          sokotoIrsResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          sokotoIrsResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}

export function* getPaystackConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYSTACK_CONFIG_REQUEST,
    fetchPaystackConfig
  );
}
export function* getNabrollConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_NABROLL_CONFIG_REQUEST,
    fetchNabrollConfig
  );
}

export function* getRemitaConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_REMITA_CONFIG_REQUEST,
    fetchRemitaConfig
  );
}

export function* getInterswitchConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_REQUEST,
    fetchInterswitchConfig
  );
}
export function* getPayproKanoConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYPRO_KANO_CONFIG_REQUEST,
    fetchPayproKanoConfig
  );
}

export function* getPayUnimaidConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYUNIMAID_CONFIG_REQUEST,
    fetchPayUnimaidConfig
  );
}

export function* getSokotoIrsConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_SOKOTO_IRS_CONFIG_REQUEST,
    fetchSokotoIrsConfig
  );
}
